export interface WeldJobNumberSource {
  weldNumber?: unknown;
  wpsNumber?: unknown;
  job_number?: unknown;
}

export function normalizePipeJobNumber(value: unknown): string {
  return String(value ?? '').trim().toLowerCase();
}

export function getWeldJobNumber(weld: WeldJobNumberSource): string {
  return String(weld?.wpsNumber ?? weld?.job_number ?? '').trim();
}

export function splitJobNumberParts(value: unknown): string[] {
  return String(value ?? '')
    .split(',')
    .map((part) => part.trim())
    .filter((part) => part !== '');
}

function addDistinctJobNumbers(values: string[], seen: Set<string>, result: string[]): void {
  values.forEach((jobNumber) => {
    splitJobNumberParts(jobNumber).forEach((part) => {
      const normalized = normalizePipeJobNumber(part);
      if (normalized && !seen.has(normalized)) {
        seen.add(normalized);
        result.push(part);
      }
    });
  });
}

export function getDistinctJobNumbersFromWelds(
  welds: WeldJobNumberSource[]
): string[] {
  const seen = new Set<string>();
  const result: string[] = [];

  welds.forEach((weld) => {
    addDistinctJobNumbers([getWeldJobNumber(weld)], seen, result);
  });

  return result;
}

export function mergePipeJobNumbers(existing: string[], toAdd: string[]): string[] {
  const seen = new Set<string>();
  const merged: string[] = [];
  addDistinctJobNumbers([...existing, ...toAdd], seen, merged);
  return merged;
}

export function getUpdatedSourcePipeJobNumbers(
  sourcePipeExisting: string[],
  selectedWelds: WeldJobNumberSource[],
  allWeldsOnSourceView: WeldJobNumberSource[]
): string[] {  const selectedWeldNumbers = new Set(
    selectedWelds.map((weld) => String(weld.weldNumber ?? ''))
  );
  const remainingWelds = allWeldsOnSourceView.filter(
    (weld) => !selectedWeldNumbers.has(String(weld.weldNumber ?? ''))
  );
  const remainingJobNumbers = new Set(
    getDistinctJobNumbersFromWelds(remainingWelds).map(normalizePipeJobNumber)
  );

  return sourcePipeExisting.filter((jobNumber) => {
    const normalized = normalizePipeJobNumber(jobNumber);
    return normalized !== '' && remainingJobNumbers.has(normalized);
  });
}

export function havePipeJobNumbersChanged(before: string[], after: string[]): boolean {
  const normalizeList = (values: string[]) =>
    values.map(normalizePipeJobNumber).filter(Boolean).sort();

  const normalizedBefore = normalizeList(before);
  const normalizedAfter = normalizeList(after);

  return (
    normalizedBefore.length !== normalizedAfter.length ||
    normalizedBefore.some((value, index) => value !== normalizedAfter[index])
  );
}
